var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 4.05 13.95 0 9 0C4.05 0 0 4.05 0 9C0 13.5 3.2625 17.2125 7.5375 17.8875V11.5875H5.2875V9H7.5375V6.975C7.5375 4.725 8.8875 3.4875 10.9125 3.4875C11.925 3.4875 12.9375 3.7125 12.9375 3.7125V5.9625H11.8125C10.6875 5.9625 10.35 6.6375 10.35 7.3125V9H12.825L12.375 11.5875H10.2375V18C14.7375 17.325 18 13.5 18 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook2);
export default __webpack_public_path__ + "static/media/facebook 2.cf99f38160701f41895b8c776902cfde.svg";
export { ForwardRef as ReactComponent };